import './buildChart';
import './applyTheme';
import './getChart';
import './imageExporter';
import { createRmxAxios, createStandardAxios } from '../utils/ajax';
import type { ChartData } from './charting.types';
import type { NamedUuidModel } from '../../common/types/UuidModel';

const chartApi = createStandardAxios();
const rmxChartApi = createRmxAxios();
export type GraphSelection = {
  installationModelId: number;
  dataPointId: number;
};

export async function getChartData(systemProcessDataPoints: GraphSelection[], assetDataPoints: GraphSelection[], start: string, end: string) {
  return (
    await chartApi.post<{
      message?: string;
      data?: ChartData;
      hasdata: boolean;
    }>('/Charts/GetChartData', {
      SystemProcessDataPoints: systemProcessDataPoints.map((s) => ({ InstallationModelId: s.installationModelId, DataPointId: s.dataPointId })),
      AssetDataPoints: assetDataPoints.map((a) => ({ InstallationModelId: a.installationModelId, DataPointId: a.dataPointId })),
      Start: start,
      End: end
    })
  ).data;
}

type ChartSelectionData = {
  companies: NamedUuidModel[];
  sites: NamedUuidModel[];
  systemProcessId: number | null;
  assetId: number | null;
};

export async function getChartSelectionData(companyUuid: string | null, siteUuid: string | null, assetUuid: string | null, spUuid: string | null) {
  return (
    await rmxChartApi.get<ChartSelectionData>('/Charting/SelectionData', {
      params: {
        companyUuid,
        siteUuid,
        assetUuid,
        systemProcessUuid: spUuid
      }
    })
  ).data;
}
type ChartModelWithId = {
  id: number;
  name: string;
};

export type ChartInstallationModel = ChartModelWithId & {
  dataPoints: number[];
  isRmxHub: boolean;
};

type ChartingInstallationModelStructure = {
  systemProcesses: ChartInstallationModel[];
  assets: ChartInstallationModel[];
  dataPoints: Record<number, ChartModelWithId>;
};

export async function getChartInstallationModelStructures(siteUuid: string) {
  return (
    await rmxChartApi.get<ChartingInstallationModelStructure>('/Charting/InstallationModelStructures', {
      params: {
        siteUuid
      }
    })
  ).data;
}

// @ts-ignore
window.getChartDataAsync = getChartData;
